import React, { useContext, useState, useEffect } from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import styled, { ThemeProvider } from "styled-components"
import { motion, useAnimation } from "framer-motion"


import { lightTheme, darkTheme } from "styles/theme"
import { useDarkMode } from "hooks"
import Context from "context"
import GlobalStyle from "styles/globalStyle"
import Header from "./header"
import Footer from "./footer"
import CookieBar from "components/cookieBar"
import SplashScreen from "components/splashScreen"
import { useCookieBar } from "config"
import background from "content/images/background.png"

import Navbar from "components/navbar"
import { detectMobileAndTablet, isSSR } from "../utils/"
import chevron from "content/images/chevron.svg"

// https://medium.com/@chrisfitkin/how-to-smooth-scroll-links-in-gatsby-3dc445299558
if (typeof window !== "undefined") {
  require("smooth-scroll")('a[href*="#"]')
}

const StyledLayoutWrapper = styled.div`
  width: 100%;
`

const StyledLayout = styled.div`
  width: 100%;
`

const HomeLayout = ({ children, home, details, nocv, lang }) => {
  const { isIntroDone } = useContext(Context).state
  
  const [windowWidth, setWindowWidth] = useState(0)


  useEffect(() => {
    let handleWindowSizeChange
    // if (isSSR) is necessary to prevent error during the gatsby build
    if (!isSSR) {
      handleWindowSizeChange = () => setWindowWidth(window.innerWidth)
      // set initial innerWidth when component mounts
      setWindowWidth(window.innerWidth)
    }
    // Add event listener to update windowWidth in state
    window.addEventListener("resize", handleWindowSizeChange)
    return () => window.removeEventListener("resize", handleWindowSizeChange)
  }, [windowWidth])

  // Required for animation - start after the splashScreen sequence is done
  const controls = useAnimation()
  useEffect(() => {
    if (isIntroDone)
      controls.start({ opacity: 1, y: 0, transition: { delay: 0.2 } })
  }, [isIntroDone, controls])

  let navigation
  if (detectMobileAndTablet(windowWidth)) {
    navigation = null
  } else {
    navigation = <Navbar home={home} nocv={nocv} lang={lang} initial={{ opacity: 0, y: -10 }} animate={controls} />
  }

  const darkModeEnabled = useDarkMode()
  const theme = darkModeEnabled ? darkTheme : lightTheme
  
 // const urlSearchParams =  new URLSearchParams(!isSSR && window.location.search).get('params') || new URLSearchParams(!isSSR && window.location.search).get('token')
const urlSearchParams = "eyJzb3VyY2Vfa2V5IjoiZDVjZWY3YzQyYWU4MjFiZDM1MmQ2MDBlYzU0MTExYWI3MWNhZWMxMCIsInNvdXJjZV9rZXlfc3RvcmluZyI6IjY5MDk5ZTMxNTQyMWFiM2U4MmE5MGI4Nzk5NjBiN2VlNmEwZTJjNDEiLCJib2FyZF9rZXlzIjpbIjg4M2Y1YjUwMjM3NTMxZTYyOGI3YTAxMGMzNTcyZGYxYmVjMDJlNGIiXSwiYWxnb3JpdGhtX2tleSI6ImQ2NzYyZjUyMDhlMjhkNzYwZDE5ZGY2ZjhiMTQzNzdjNTVlYzQ4YjYiLCJzZWNyZXRfa2V5IjoiYXNrXzg1MGI0NDU1ZGExNjNhMTI0OWJlYjc2NGJkOTYxMTE0IiwibmFtZSI6IkFJIEpvYnNpdGUiLCJsYW5ndWFnZSI6ImZyIiwiY2F0ZWdvcnlfbmFtZSI6InBvbGVfZW1wbG9pX3JvbWVMaWJlbGxlIiwiY2F0ZWdvcnlfbGlzdCI6IiIsIndlbGNvbWVfbWVzc2FnZSI6IlLDqXbDqWxleiB2b3RyZSBwbGVpbiBwb3RlbnRpZWwgZXQgcmVqb2lnbmV6IG5vdHJlIMOpcXVpcGUgZGUgdGFsZW50cyBleGNlcHRpb25uZWxzIGFuaW3DqWUgcGFyIHVuZSBtaXNzaW9uLiBFbiBzb3VtZXR0YW50IHZvdHJlIENWLCB2b3VzIHNlcmV6IGFzc29jacOpIMOgIGwnb3Bwb3J0dW5pdMOpIHBhcmZhaXRlIHBvdXIgbWV0dHJlIGVuIHZhbGV1ciB2b3MgY29tcMOpdGVuY2VzIGV0IHZvdHJlIGludGVsbGlnZW5jZS4gUGFzc2V6IMOgIGwnw6l0YXBlIHN1aXZhbnRlIGRlIHZvdHJlIHBhcmNvdXJzIHByb2Zlc3Npb25uZWwgZXQgZMOpY291dnJleiB1bmUgY3JvaXNzYW5jZSBpbGxpbWl0w6llIC0gY29tbWVuY2V6IG1haW50ZW5hbnQgISIsImNvbnNlbnQiOjAsImNvbnNlbnRfZGVzY3JpcHRpb24iOiJCeSBjbGlja2luZyBvbiBcIkkgYWNjZXB0IHRoZSBUZXJtcyBvZiBVc2UsXCIgSSBhY2NlcHQgdGhlIFRlcm1zIG9mIFVzZSB0aGF0IGFsbG93IHRoaXMgd2Vic2l0ZSB0byBzdG9yZSBteSBkYXRhLCBjYWxjdWxhdGUgbXkgc3VpdGFiaWxpdHkgd2l0aCB0aGUgam9iIG9mZmVycywgYW5kIHNoYXJlIG15IHByb2ZpbGUgd2l0aCByZWNydWl0ZXJzIGluIHRoaXMgY29tcGFueS4iLCJ0YWdzIjpbeyJpY29uIjoiZmEtaGFzaHRhZyIsIm5hbWUiOiJSb21lIGNvZGU6ICIsInZhbHVlIjoicG9sZV9lbXBsb2lfcm9tZUNvZGUifSx7Imljb24iOiJmYS10YWdzIiwibmFtZSI6IlJvbWUgbGliZWxsZTogIiwidmFsdWUiOiJwb2xlX2VtcGxvaV9yb21lTGliZWxsZSJ9LHsiaWNvbiI6ImZhLWFuY2hvciIsIm5hbWUiOiJBcHBsaWNhdGlvbjogIiwidmFsdWUiOiJwb2xlX2VtcGxvaV9hcHBlbGxhdGlvbkxpYmVsbGUifSx7Imljb24iOiJmYS1hZGRyZXNzLWJvb2siLCJuYW1lIjoiTmF0dXJlIGRlIGNvbnRyYXQ6ICIsInZhbHVlIjoicG9sZV9lbXBsb2lfY29udHJhY3ROYXR1cmUifSx7Imljb24iOiJmYS1jbG9uZSIsIm5hbWUiOiJUeXBlIGRlIGNvbnRyYXQ6ICIsInZhbHVlIjoicG9sZV9lbXBsb2lfY29udHJhY3RUeXBlIn0seyJpY29uIjoiZmEtc3VpdGNhc2UiLCJuYW1lIjoiRXhwZXJpZW5jZTogIiwidmFsdWUiOiJwb2xlX2VtcGxvaV9leHBlcmllbmNlIn0seyJpY29uIjoiZmEtbW9uZXkiLCJuYW1lIjoiU2FsYWlyZTogIiwidmFsdWUiOiJwb2xlX2VtcGxvaV9zYWxhcnkifSx7Imljb24iOiJmYS1ob3VyZ2xhc3MtZW5kIiwibmFtZSI6IkhldXJlcyBkZSB0cmF2YWlsOiAiLCJ2YWx1ZSI6InBvbGVfZW1wbG9pX3dvcmtpbmdfaG91cnMifSx7Imljb24iOiJmYS1ncmFkdWF0aW9uLWNhcCIsIm5hbWUiOiJRdWFsaWZpY2F0aW9uOiAiLCJ2YWx1ZSI6InBvbGVfZW1wbG9pX3F1YWxpZmljYXRpb24ifSx7Imljb24iOiJmYS1idWlsZGluZy1vIiwibmFtZSI6IlNlY3RldXI6ICIsInZhbHVlIjoicG9sZV9lbXBsb2lfc2VjdGV1ckFjdGl2aXRlIn0seyJpY29uIjoiZmEtZmlsZS1vIiwibmFtZSI6IkNvbnRyYWN0OiIsInZhbHVlIjoicG9sZV9lbXBsb2lfY29udGFjdC1uYW1lIn0seyJpY29uIjoiZmEtZW52ZWxvcGUiLCJuYW1lIjoiRW1haWw6IiwidmFsdWUiOiJwb2xlX2VtcGxvaV9jb250YWN0LWVtYWlsIn0seyJpY29uIjoiZmEtcGhvbmUiLCJuYW1lIjoiUGhvbmU6ICIsInZhbHVlIjoicG9sZV9lbXBsb2lfY29udGFjdC1waG9uZSJ9XSwibG9nbyI6Imh0dHBzOi8vaHJmbG93LWFpLmltZ2l4Lm5ldC9sb2dvLnN2ZyJ9"

  return (
    <StyledLayoutWrapper id="layout-home-wrapper" details={details} data-usecookiebar={useCookieBar}>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <StyledLayout home={home} details={details}>
          {children}
        </StyledLayout>
      </ThemeProvider>
    </StyledLayoutWrapper>
  )
}

HomeLayout.propTypes = {
  children: PropTypes.any,
}

export default HomeLayout
